import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    input,
    output,
    signal,
    viewChild,
} from '@angular/core';

import { AgentTask } from 'AgentApp/ts/interfaces/agent-task.interface';

import { DropdownHelperService } from 'Angular/services/dropdown-helper.service';

import { IconModule } from 'Angular/features/directives/icon/icon.module';

@Component({
    selector: 'ycn-agent-tasks',
    imports: [IconModule],
    templateUrl: './agent-tasks.component.html',
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentTasksComponent implements AfterViewInit {
    private readonly _dropdownHelperService = inject(DropdownHelperService);

    protected readonly visibleTasks = input.required<AgentTask[]>();

    protected readonly completedTasks = input.required<AgentTask[]>();

    protected readonly inProgressTasks = input.required<AgentTask[]>();

    protected readonly cancelledTasks = input.required<AgentTask[]>();

    protected readonly hasInProgressTasks = input.required<boolean>();

    protected readonly completionPercentage = input.required<number>();

    protected readonly taskSelected = output<AgentTask>();

    protected readonly deleteTask = output<AgentTask>();

    protected readonly hideTask = output<AgentTask>();

    protected readonly isDropdownOpen = signal(false);

    protected readonly chosenTab = signal<'completed' | 'in-progress'>('in-progress');

    protected readonly dropdownMenu = viewChild<ElementRef>('dropdownMenu');

    ngAfterViewInit(): void {
        const dropdown = this.dropdownMenu();
        if (dropdown) {
            this._dropdownHelperService.setCloseHandler(dropdown.nativeElement, (): void => {
                if (this.isDropdownOpen()) {
                    this.isDropdownOpen.set(false);
                }
            });
        }
    }

    toggleDropdown(): void {
        this.isDropdownOpen.update((x) => !x);
    }

    changeTab(tab: 'completed' | 'in-progress', event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.chosenTab.set(tab);
    }

    onTaskClicked(task: AgentTask, event: Event): void {
        event.stopPropagation();
        this.taskSelected.emit(task);
    }

    onDeleteTask(task: AgentTask, event: Event): void {
        event.stopPropagation();
        this.deleteTask.emit(task);
    }

    onHideTask(task: AgentTask, event: Event): void {
        event.stopPropagation();
        this.hideTask.emit(task);
    }
}
